import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './termsOfService.css';

class TermsOfService extends Component {
  render() {
    return (
      <div className="TermsOfService">
        <div className="TermsOfServiceContainer">
          <h1>ACTFIT LTD TERMS OF SERVICE</h1>
          <div className="TermsOfServiceBody">
            <b>Last Updated: 19 February 2018</b>
            <p>
              ACTFIT is an intermediary and booking platform that gives you
              access to the best Service Providers, and lets you buy courses,
              classes and other services (collectively, the “Services”). The
              ACTFIT website and any other website through which ACTFIT makes
              the Services available (collectively, the “Site”), as well as the
              application for mobile devices (the “Application”) is operated by
              ACTFIT Ltd. (“ACTFIT”). Please read carefully the following Terms
              of Use, which may be updated by ACTFIT from time to time without
              notice to you (the Terms of Use, as modified from time to time,
              the “Terms”). The most current version of the Terms can be
              accessed at any time at{' '}
              <Link to="/terms">https://www.actfit.com/terms</Link>.
            </p>
            <p>
              By accessing, browsing, and/or using the Site or the Application
              you accept and agree to be bound to these Terms. In addition, when
              using particular ACTFIT services, you also shall be subject to any
              posted guidelines, FAQ’s, or rules applicable to such services,
              which may be posted and modified from time to time. If you do not
              agree to these Terms, you have no right to obtain information from
              or otherwise continue using the Site or Application. Failure to
              use the Site and Application in accordance with these Terms may
              subject you to civil and criminal penalties.
            </p>
            <p>
              THE SITE AND APPLICATION COMPRISE AN INTERMEDIARY AND BOOKING
              PLATFORM THROUGH WHICH SERVICE PROVIDERS (DEFINED BELOW) MAY
              CREATE LISTINGS (DEFINED BELOW) FOR SERVICES AND CONSUMERS
              (DEFINED BELOW) MAY LEARN ABOUT AND BOOK SERVICES DIRECTLY WITH
              THE SERVICE PROVIDERS. YOU UNDERSTAND AND AGREE THAT ACTFIT IS NOT
              A PARTY TO ANY AGREEMENTS ENTERED INTO BETWEEN SERVICE PROVIDERS
              AND CONSUMERS, NOR IS ACTFIT A BROKER, AGENT OR INSURER. ACTFIT
              HAS NO CONTROL OVER THE CONDUCT OF SERVICE PROVIDERS, CONSUMERS
              AND OTHER USERS OF THE SITE OR APPLICATION OR ANY CLASSES, COURSES
              AND/OR SERVICES, AND DISCLAIMS ALL LIABILITY IN THIS REGARD.
            </p>

            <h3>DEFINITIONS</h3>
            <p>
              <strong>Content.</strong>
              Means text, graphics, images, music, software (excluding the
              Application), audio, video, information or other materials.
            </p>
            <p>
              <strong>Consumer.</strong>
              Consumer means a User who requests from a Service Provider a
              booking of a Service via the Site or Application, or a User who
              consumed a service via the Site.
            </p>
            <p>
              <strong>Service.</strong>
              Any class, course or other service offered on the Site or
              Application.
            </p>
            <p>
              <strong>Service Providers.</strong>
              Means a User who offers a Service via the Site or Application.
            </p>
            <p>
              <strong>Listing.</strong>
              Means Services that are offered by Service Providers as available
              for rental or sale via the Site or Application.
            </p>
            <p>
              <strong>User.</strong>
              Means any person who completes the ACTFIT’s account registration
              process, including, but not limited to Service Providers and
              Consumers, as described above.
            </p>
            <p>
              <strong>Tax or Taxes.</strong>
              Mean any sales taxes, value added taxes (VAT), goods and services
              taxes (GST) and other similar municipal, state and federal
              indirect or other withholding and personal or corporate income
              taxes.
            </p>
            <p>
              Certain areas of the Site and Application (and your access to or
              use of certain aspects of the Services) may have different terms
              and conditions posted or may require you to agree with and accept
              additional terms and conditions. If there is a conflict between
              these Terms and terms and conditions posted for a specific area of
              the Site or Application, the latter terms and conditions will take
              precedence with respect to your use of or access to that area of
              the Site or Application.
            </p>
            <p>
              YOU ACKNOWLEDGE AND AGREE THAT, BY ACCESSING OR USING THE SITE OR
              APPLICATION OR BY DOWNLOADING OR POSTING ANY CONTENT FROM OR ON
              THE SITE, VIA THE APPLICATION OR THROUGH THE SERVICES, YOU ARE
              INDICATING THAT YOU HAVE READ, AND THAT YOU UNDERSTAND AND AGREE
              TO BE BOUND BY THESE TERMS, WHETHER OR NOT YOU HAVE REGISTERED
              WITH THE SITE AND APPLICATION. IF YOU DO NOT AGREE TO THESE TERMS,
              THEN YOU HAVE NO RIGHT TO ACCESS OR USE THE SITE, APPLICATION,
              SERVICES, OR CONTENT.
            </p>
            <p>
              If you accept or agree to these Terms on behalf of a company or
              other legal entity, you represent and warrant that you have the
              authority to bind that company or other legal entity to these
              Terms and, in such event, “you” and “your” will refer and apply to
              that company or other legal entity.
            </p>

            <h3>BOOKINGS AND FINANCIAL TERMS</h3>
            <p>
              <strong>
                Bookings and Financial Terms for Service Providers.
              </strong>
              When a booking is made via the Site or Application, we will share
              with the respective Service Provider the contact information of
              the consumer who has made the booking. ACTFIT will send the
              Consumer an email, text message or message via the Application
              confirming such booking, depending on the selections made via the
              Site or Application. The amounts due and payable by a consumer
              relating to a Service Provider’s Services are the “Service Fees”.
              Please note that it is the Service Providers and not ACTFIT who
              determine the Service Fees. ACTFIT then charges Service Providers
              a fee based upon the effective costs for payment processing, which
              are the “Intermediary Fees”. ACTFIT will collect the Service Fees
              at the time of booking and will initiate payment of the Service
              Fees less the Intermediary Fees to the Service Providers at the
              end of each month (except to the extent that a refund is due to
              the consumer). Where applicable, Taxes may be charged in addition
              to the Intermediary Fees.
            </p>
            <p>
              <strong>
                Appointment of ACTFIT as Payment Collection Agent for Service
                Providers.
              </strong>
              Each Service Provider hereby appoints ACTFIT as the Service
              Provider’s limited payment collection agent solely for the purpose
              of collecting payments made by Consumers on behalf of the Service
              Provider. Each Service Provider agrees that payment made by a
              consumer through ACTFIT shall be considered the same as a payment
              made directly to the Service Providers. In addition to this the
              Service Providers will make the Services available to consumer in
              the agreed upon manner as if the Service Provider has received the
              Service Fees. Each Service Provider agrees that, ACTFIT may in its
              own discretion cancel a booking and refund to the consumer the
              Service Fees. In accepting appointment as the limited authorized
              agent of the Service Providers, ACTFIT assumes no liability for
              any acts or omissions of the Service Providers.
            </p>
            <p>
              <strong>
                Cancellation of Bookings through Service Providers.
              </strong>
              The Service Providers are automatically accepting the booking
              without notice, unless if they reject it in writing to
              info@actfit.com within two hours of when the booking is requested
              (as determined by ACTFIT in its sole discretion). If a requested
              booking is cancelled (i.e. not confirmed by the applicable Service
              Providers), any amounts collected by ACTFIT will be refunded to
              such consumer, and any pre-authorization of such consumer’s credit
              card will be released, if applicable.
            </p>
            <p>
              <strong>Listing Fees.</strong>
              Please note that ACTFIT does not currently charge fees for the
              creation of Listings. However, you acknowledge and agree that
              ACTFIT reserves the right, in its sole discretion, to charge you
              for and collect fees from you for the creation of Listings. Please
              note that ACTFIT will provide notice of any Listing fee collection
              via the Site and/or Application, prior to implementing such a
              Listing fee feature.
            </p>
            <p>
              <strong>Bookings and Financial Terms for Consumers.</strong>
              The Service Providers, not ACTFIT, are solely responsible for
              honouring any confirmed bookings and making available any Services
              booked through the Site or Application. If you, as a consumer,
              choose to enter into a transaction with a Service Provider for the
              booking of a Service, you agree and understand that you will be
              required to enter into an agreement with the Service Provider and
              you agree to accept any terms, conditions, rules and restrictions
              associated with such Services imposed by the Service Provider. You
              acknowledge and agree that you, and not ACTFIT, will be
              responsible for performing the obligations of any such agreements,
              that ACTFIT is not a party to such agreements, and that, with the
              exception of its payment obligations hereunder, ACTFIT disclaims
              all liability arising from or related to any such agreements. You
              acknowledge and agree that, notwithstanding the fact that ACTFIT
              is not a party to the agreement between you and the Service
              Providers, ACTFIT acts as the Service Providers’ payment
              collection agent for the limited purpose of accepting payments
              from you on behalf of the Service Providers. Upon your payment of
              amounts to ACTFIT, which are due to the Service Providers, your
              payment obligation to the Service Providers for such amounts is
              extinguished, and ACTFIT is responsible for remitting such
              amounts, less Intermediary Fees, to the Service Providers. In the
              event that ACTFIT does not remit any such amounts to a Service
              Provider, such Service Provider will have recourse only against
              ACTFIT.
            </p>
            <p>
              <strong>Other Fees.</strong>
              In addition to the Service Fees, you are responsible for paying
              cancellation fees if you do not cancel your Service with
              appropriate notice. The Service Fee only gives you access to the
              Service for which you signed up. The venue may have additional
              fees for use of additional services.
            </p>
            <p>
              <strong>Termination by ACTFIT.</strong>
              You agree that ACTFIT, in its sole discretion and for any or no
              reason, may terminate any account (or any part thereof) you may
              have with ACTFIT or use of the Site and remove and discard all or
              any part of your account or any content uploaded by you, at any
              time. ACTFIT may also in its sole discretion and at any time
              discontinue providing access to the Site, or any part thereof,
              with or without notice. You agree that any termination of your
              access to the Site or any account you may have or portion thereof
              may be effected without prior notice, and you agree that ACTFIT
              will not be liable to you or any third-party for any such
              termination. ACTFIT does not permit copyright infringing
              activities on the Site and reserves the right to terminate access
              to the Site and remove all content submitted by any persons who
              are found to be repeat infringers. Any suspected fraudulent,
              abusive, or illegal activity that may be grounds for termination
              of your use of the Site may be referred to appropriate law
              enforcement authorities. These remedies are in addition to any
              other remedies ACTFIT may have at law or in equity.
            </p>

            <h3>BILLING</h3>
            <p>
              <strong>Billing.</strong>
              You must provide us with a current, valid, accepted method of
              payment (as such may be updated from time to time, “Payment
              Method”) to buy Services through ACTFIT.
            </p>
            <p>
              <strong>No Refunds.</strong>
              PAYMENTS ARE NONREFUNDABLE AND THERE ARE NO REFUNDS OR CREDITS FOR
              PARTIALLY USED SERVICES OR PERIODS. At any time, and for any
              reason, we may provide a refund, discount, or other consideration
              to some or all of our members (“credits”). The amount and form of
              such credits, and the decision to provide them, are at our sole
              and absolute discretion. The provision of credits in one instance
              does not entitle you to credits in the future for similar
              instances, nor does it obligate us to provide credits in the
              future, under any circumstance.
            </p>
            <p>
              <strong>Payment Methods.</strong>
              You may edit your Payment Method information by emailing us at
              info@actfit.com. If a payment is not successfully settled, due to
              expiration, insufficient funds, or otherwise, and you do not edit
              your Payment Method information or cancel your account (see,
              “Cancellation” below), you remain responsible for any uncollected
              amounts and authorize us to continue billing the Payment Method,
              as it may be updated. This may result in a change to your payment
              billing dates.
            </p>
            <p>
              <strong>Payment Processing</strong>
              In order to establish a booking, you understand and agree that
              ACTFIT, on behalf of the Service Providers, reserves the right, in
              its sole discretion, to (i) obtain a pre-authorization via your
              credit card for the Total Fees or (ii) charge your credit card a
              nominal amount, not to exceed one dollar (GBP 1.00), or a similar
              sum in the currency in which you are transacting (e.g. one euro or
              one US dollar) to verify your credit card. Once ACTFIT receives
              confirmation of your booking, ACTFIT will collect the Service Fees
              in accordance with the terms and conditions of these Terms. Please
              note that ACTFIT cannot control any fees that may be charged to a
              consumer by his or her bank related to ACTFIT’s collection of the
              Service Fees, and ACTFIT disclaims all liability in this regard.
              In connection with your requested booking, you will be asked to
              provide customary billing information such as name, billing
              address and credit card information either to ACTFIT or its
              third-party payment processor. You agree to pay ACTFIT for any
              confirmed bookings made in connection with your ACTFIT Account in
              accordance with these Terms by one of the methods described on the
              Site or Application. You hereby authorize the collection of such
              amounts by charging the credit card provided as part of requesting
              the booking, either directly by ACTFIT or indirectly, via a
              third-party online payment processor or by one of the payment
              methods described on the Site or Application. You also authorize
              ACTFIT to charge your credit card in the event of damage caused at
              a class or service. If you are directed to ACTFIT’s third-party
              payment processor, you may be subject to terms and conditions
              governing use of that third-party’s service and that third-party’s
              personal information collection practices. Please review such
              terms and conditions and privacy policy before using the services.
              Once your confirmed booking transaction is complete you will
              receive a confirmation email or through the Application
              summarizing your confirmed booking.
            </p>
            <p>
              <strong>Payment Processing; STRIPE</strong>
              Payment processing services for Service Providers on ACTFIT are
              provided by Stripe and are subject to the{' '}
              <a href="https://stripe.com/connect-account/legal">
                Stripe Connected Account Agreement
              </a>, which includes the{' '}
              <a href="https://stripe.com/legal">Stripe Terms of Service</a>{' '}
              (collectively, the “Stripe Services Agreement”). By agreeing to
              these terms or continuing to operate as a Service Provider on
              ACTFIT, you agree to be bound by the Stripe Services Agreement, as
              the same may be modified by Stripe from time to time. As a
              condition of ACTFIT enabling payment processing services through
              Stripe, you agree to provide ACTFIT accurate and complete
              information about you and your business, and you authorize ACTFIT
              to share it and transaction information related to your use of the
              payment processing services provided by Stripe.
            </p>

            <h3>
              ELIGIBILITY; REGISTRATION INFORMATION AND PASSWORD; SITE ACCESS
            </h3>
            <p>
              YOU MUST BE 18 YEARS OF AGE OR OLDER TO USE THIS SITE OR TO BUY
              SERVICES. THE SITE IS NOT AVAILABLE TO PERSONS SUSPENDED OR
              REMOVED FROM THE SITE BY ACTFIT. BY USING THE SITE, YOU REPRESENT
              THAT YOU HAVE NOT BEEN PREVIOUSLY SUSPENDED OR REMOVED FROM THE
              SITE. If you are using or opening an account on the Site on behalf
              of a company, entity, or organization (a “Subscribing
              Organization”), then you represent and warrant that you are an
              authorized representative of that Subscribing Organization with
              the authority to bind such organization to these Terms; and agree
              to be bound by these Terms on behalf of such Subscribing
              Organization.
            </p>
            <p>
              ACTFIT is not an owner or operator of studios nor is it a provider
              or manager of Services. ACTFIT’s responsibilities are limited to:
              (i) facilitating the availability of the Site and Application and
              (ii) serving as the limited payment collection agent of each
              Service Provider for the purpose of accepting payments from
              Consumers on behalf of the Service Providers.
            </p>
            <p>
              PLEASE NOTE THAT, AS STATED ABOVE, THE SITE AND APPLICATION ARE
              INTENDED TO BE USED TO FACILITATE SERVICE PROVIDERS AND CONSUMERS
              MEETING EACH OTHER AND TO ENABLE THEM TO AGREE TO BOOKINGS OF
              SERVICES. ACTFIT CANNOT AND DOES NOT CONTROL THE CONTENT CONTAINED
              IN ANY LISTINGS AND THE CONDITION, LEGALITY OR SUITABILITY OF ANY
              CLASSES AND COURSES. ACTFIT IS NOT RESPONSIBLE FOR AND DISCLAIMS
              ANY AND ALL LIABILITY RELATED TO ANY AND ALL LISTINGS AND CLASSES
              AND COURSES. ACCORDINGLY, ANY BOOKINGS WILL BE MADE AT THE
              CONSUMER’S OWN RISK.
            </p>
            <p>
              You agree that the information you provide to ACTFIT on
              registration and at all other times will be true, accurate,
              current, and complete. You also agree that you will ensure that
              this information is kept accurate and up-to-date at all times.
              When you register, you will be asked to create a password. You are
              solely responsible for maintaining the confidentiality of your
              account and password and for restricting access to your computer,
              and you agree to accept responsibility for all activities that
              occur under your account.
            </p>
            <h3>LISTINGS OF SERVICES</h3>
            <p>
              As Service Provider, you may create Listings. To this end, you
              will be asked a variety of questions about the Services to be
              listed, including, but not limited to, the location, capacity,
              size, features, availability of the Services and pricing and
              related rules and financial terms. In order to be featured in
              Listings via the Site and Application, all Services must have
              valid physical addresses. Listings will be made publicly available
              via the Site and Application. Other Users will be able to book
              your Services via the Site and Application based upon the
              information provided in your Listing. You understand and agree
              that once a consumer requests a booking of your Service, the price
              for such Service may not be altered.
            </p>
            <p>
              You acknowledge and agree that you are responsible for any and all
              Listings you post. Accordingly, you represent and warrant that any
              Listing you post and the booking of a Service in a Listing you
              post (i) will not breach any agreements you have entered into with
              any third parties and (ii) will (a) be in compliance with all
              applicable laws, Tax requirements, and rules and regulations that
              may apply to any Services included in a Listing you post and (b)
              not conflict with the rights of third parties. Please note that
              ACTFIT assumes no responsibility for a Service Providers’
              compliance with any applicable laws, rules and regulations. ACTFIT
              reserves the right, at any time and without prior notice, to
              remove or disable access to any Listing for any reason, including
              Listings that ACTFIT, in its sole discretion, considers to be
              objectionable for any reason, in violation of these Terms or
              otherwise harmful to the Site or Application.
            </p>
            <p>
              You understand and agree that ACTFIT does not act as an insurer or
              as a contracting agent for you as a Service Provider. If a
              consumer requests a booking of your Services, any agreement you
              enter into with such consumer is between you and the consumer and
              ACTFIT is not a party thereto. Notwithstanding the foregoing,
              ACTFIT serves as the limited authorized payment collection agent
              of the Service Providers for the purpose of accepting payments
              from Consumers on behalf of the Service Providers and is
              responsible for transmitting such payments net of the Intermediary
              Fees to the Service Providers.
            </p>
            <p>
              ACTFIT recommends that Service Providers obtain appropriate
              insurance for their Services. Please review any insurance policy
              that you may have for your Services carefully, and in particular
              please make sure that you are familiar with and understand any
              exclusions to, and any deductibles that may apply for, such
              insurance policy, including, but not limited to, whether or not
              your insurance policy will cover the actions or inactions of
              Consumers (and the individuals the consumer invites to the
              Services, if applicable).
            </p>

            <h3>NO ENDORSEMENT</h3>
            <p>
              ACTFIT does not endorse any Users or any Services. In addition,
              although these Terms require Users to provide accurate
              information, we do not attempt to confirm, and do not confirm, any
              User’s purported identity. You are responsible for determining the
              identity and suitability of others who you contact via the Site or
              Application. By using the Site or Application, you agree that any
              legal remedy or liability that you seek to obtain for actions or
              omissions of other Users or other third parties will be limited to
              a claim against the particular Users or other third parties who
              caused you harm and you agree not to attempt to impose liability
              on, or seek any legal remedy from ACTFIT with respect to such
              actions or omissions. Accordingly, we encourage you to communicate
              directly with other Users on the Site and Application regarding
              any bookings or Listings. This limitation shall not apply to any
              claim by a Service Provider against ACTFIT regarding the
              remittance of payments received from a consumer by ACTFIT on
              behalf of a Service Provider, which instead shall be subject to
              the limitations described in the section below entitled
              “Limitation of Liability”.
            </p>
            <p>
              <strong>Privacy.</strong>
              Your privacy is important to ACTFIT. The ACTFIT Privacy Policy is
              hereby incorporated into these Terms by reference. Please read the
              privacy policy carefully for information relating to ACTFIT’s
              collection, use, and disclosure of your personal information.
            </p>
            <p>
              <strong>Prohibited Conduct.</strong>
              By using the Site, you promise not to: Harass, threaten, or
              defraud Users; Make unsolicited offers, advertisements, proposals,
              or send junk mail to Users; Impersonate another person or access
              another User’s account without that person’s permission; Share
              ACTFIT-issued passwords with any third-party or encourage any
              other User to do so; Permit third parties to use any services
              booked under your own membership, including other members;
              Misrepresent the source, identity, or content of information
              transmitted via the Site, including deleting the copyright or
              other proprietary rights; Upload material (e.g. virus) that is
              damaging to computer systems or data of ACTFIT or Users of the
              Site; Upload copyrighted material that is not your own or that you
              do not have the legal right to distribute, display, and otherwise
              make available to others; or Upload or send to Users pornographic,
              threatening, embarrassing, hateful, racially or ethnically
              insulting, libellous, or otherwise inappropriate content.
            </p>
            <p>
              <strong>Prohibited Uses.</strong>
              Those who choose to access the Site or Application do so at their
              own initiative and are responsible for compliance with all local
              rules including, without limitation, rules about the internet,
              data, email, or privacy. As a condition of your use of the Site or
              Application, you will not use the Site or Application for any
              purpose that is unlawful or prohibited by these Terms. You may not
              use the Site or Application in any manner that, in our sole
              discretion, damage, disable, overburden, or impair it or interfere
              with any other party’s use and enjoyment of the Site or
              Application. You may not attempt to gain unauthorized access to
              the Site or Application, or any part of the Site or Application,
              other accounts, computer systems or networks connected to the Site
              or Application, or any part of them, through hacking, password
              mining, or any other means or interfere or attempt to interfere
              with the proper working of the Site or Application or any
              activities conducted on the Site or Application. You may not
              remove, circumvent, disable, damage or otherwise interfere with
              security-related features of the Site or Application, any features
              that prevent or restrict use or copying of any content accessible
              through the Site or Application, or any features that enforce
              limitations on the use of the Site or Application or the Content.
              You may not obtain or attempt to obtain any materials or
              information through any means not intentionally made available
              through the Site or Application. You agree neither to modify the
              Site or Application in any manner or form, nor to use modified
              versions of the Site or Application, including (without
              limitation) for the purpose of obtaining unauthorized access to
              the Site or Application. The Site may contain robot exclusion
              headers. You agree that you will not use any robot, spider,
              scraper, or other automated means to access the Site or
              Application for any purpose without our express written permission
              or bypass our robot exclusion headers or other measures we may use
              to prevent or restrict access to the Site or Application. By
              accessing or using the Site or Application, you represent and
              warrant that you are 18 or older. ACTFIT reserves the right to
              refuse service, terminate accounts, remove or edit content, or
              cancel orders in their sole discretion.
            </p>
            <p>
              <strong>General User Submissions.</strong>
              The Site provides certain features which enable you and other
              Users to submit, post, and share content with other Users, which
              may include without limitation text, graphic and pictorial works,
              or any other Content submitted by you and other Users through the
              Site (“User Submissions”). User Submissions are displayed for
              informational purposes only and are not controlled by ACTFIT.
              ACTFIT cannot guarantee any anonymity or confidentiality with
              respect to any User Submissions, and strongly recommends that you
              think carefully about what you upload to the Site. You understand
              that all User Submissions are the sole responsibility of the
              person from whom such User Submission originated. This means that
              you, and not ACTFIT, are entirely responsible for all User
              Submissions that you upload, post, e-mail, transmit, or otherwise
              make available through the Site.
            </p>
            <p>
              <strong>Right to Remove or Edit User Submissions.</strong>
              ACTFIT makes no representations that it will publish or make
              available on the Site any User Submissions, and reserves the
              right, in its sole discretion, to refuse to allow any User
              Submissions on the Site, or to edit or remove any User Submission
              at any time with or without notice. Without limiting the
              generality of the preceding sentence, ACTFIT will remove User
              Submissions upon receipt of a compliant takedown notice.
            </p>
            <p>
              <strong>License Grant by you to ACTFIT.</strong>
              You retain all your ownership rights in original aspects of your
              User Submissions. By submitting User Submissions to ACTFIT, you
              hereby grant ACTFIT and its affiliates, sublicensees, partners,
              designees, and assignees of the Site (collectively, the “ACTFIT
              Licensees”) a worldwide, non-exclusive, fully paid-up,
              royalty-free, perpetual, irrevocable, sublicensable, and
              transferable license to use, reproduce (including by making
              mechanical reproductions), distribute, modify, adapt, prepare
              derivative works of, publicly display, publicly perform, and
              otherwise exploit your User Submissions and derivatives thereof in
              connection with the Site and ACTFIT’s (and its successors’)
              business, including, without limitation, for marketing, promoting,
              and redistributing part or all of the Site (and derivative works
              thereof), in any media formats and through any media channels now
              known or hereafter discovered or developed.
            </p>
            <p>
              <strong>User Submissions Representations and Warranties.</strong>
              You are solely responsible for your own User Submissions and the
              consequences of posting or publishing them. In connection with
              User Submissions, you affirm, represent, and warrant that: (i) you
              own, or have the necessary licenses, rights, consents, and
              permissions to use and authorize ACTFIT to use all patent,
              trademark, copyright, or other proprietary rights in and to your
              User Submissions to enable inclusion and use of your User
              Submissions in the manner contemplated by ACTFIT and these Terms,
              and to grant the rights and license set forth above, and (ii) your
              User Submissions, ACTFIT or any ACTFIT Licensee’s use of such User
              Submissions pursuant to these Terms, and ACTFIT’s or any of ACTFIT
              Licensee’s exercise of the license rights set forth above, do not
              and will not: (a) infringe, violate, or misappropriate any
              third-party right, including any copyright, trademark, patent,
              trade secret, moral right, privacy right, right of publicity, or
              any other intellectual property or proprietary right; (b) cause
              injury to any other person; (c) violate these Terms or any
              applicable law or regulation; or (d) require obtaining a license
              from or paying fees or royalties to any third-party for the
              exercise of any rights granted in these Terms, including, by way
              of example and not limitation, the payment of any royalties to any
              copyright owners, including any royalties to any agency,
              collection society, or other entity that administers such rights
              on behalf of others. ACTFIT may, but is not obligated to, monitor
              and edit or remove any activity or content, including but not
              limited to content that ACTFIT determines in its sole discretion
              to be violating the standards of this Site. ACTFIT takes no
              responsibility and assumes no liability for any User Submissions.
            </p>
            <p>
              Inaccurate or Offensive User Submissions. You understand that when
              using the Site, you may be exposed to User Submissions from a
              variety of sources and that ACTFIT does not endorse and is not
              responsible for the accuracy, usefulness, safety, or intellectual
              property rights of or relating to such User Submissions. You
              further understand and acknowledge that you may be exposed to User
              Submissions that are inaccurate, offensive, indecent, or
              objectionable. YOU AGREE TO WAIVE, AND HEREBY DO WAIVE, ANY LEGAL
              OR EQUITABLE RIGHTS OR REMEDIES YOU HAVE OR MAY HAVE AGAINST
              ACTFIT WITH RESPECT THERETO.
            </p>
            <p>
              <strong>Feedback.</strong>
              If you provide ACTFIT with any comments, bug reports, feedback, or
              modifications proposed or suggested by you to the Site
              (“Feedback”), ACTFIT shall have the right to use such Feedback at
              its discretion, including, but not limited to the incorporation of
              such suggested changes into the Site. You hereby grant ACTFIT a
              perpetual, irrevocable, nonexclusive license under all rights
              necessary to incorporate and use your Feedback for any purpose.
            </p>
            <p>
              <strong>Additional Terms.</strong>
              When using the site, you will be subject to any additional posted
              guidelines or rules applicable to specific products, services, or
              features, which may be posted from time to time (the “FAQ’s”). All
              such FAQ’S are hereby incorporated by reference into the terms.
            </p>
            <p>
              <strong>Ownership and Proprietary Rights.</strong>
              The Site is owned and operated by ACTFIT. The visual interfaces,
              graphics, design, compilation, information, computer code,
              products, software (including any downloadable software),
              services, and all other elements of the Site provided by ACTFIT
              (“Materials”) are protected by copyright, trade dress, patent, and
              trademark laws, international conventions, and all other relevant
              intellectual property and proprietary rights, and applicable laws.
              Except for any content uploaded by you, all Materials contained on
              the Site are the copyrighted property of ACTFIT or its
              subsidiaries or affiliated companies and/or third-party licensors.
              All trademarks, service marks, and trade names are proprietary to
              ACTFIT or its affiliates and/or third-party licensors. Except as
              expressly authorized by ACTFIT, you agree not to sell, license,
              distribute, copy, modify, publicly perform or display, transmit,
              publish, edit, adapt, create derivative works from, or otherwise
              make unauthorized use of the Materials.
            </p>
            <p>
              <strong>Third-party sites, products and services.</strong>
              The Site may include links to other web sites or services (“Linked
              Sites”) solely as a convenience to users. ACTFIT does not endorse
              any such Linked Sites or the information, material, products, or
              services contained on other linked sites or accessible through
              other Linked Sites. Furthermore, ACTFIT makes no express or
              implied warranties with regard to the information, material,
              products, or services that are contained on or accessible through
              linked sites. ACCESS AND USE OF LINKED SITES, INCLUDING THE
              INFORMATION, MATERIAL, PRODUCTS, AND SERVICES ON LINKED SITES OR
              AVAILABLE THROUGH LINKED SITES, IS SOLELY AT YOUR OWN RISK. Your
              correspondence or business dealings with, or participation in
              promotions of, advertisers found on or through the Site are solely
              between you and such advertiser. YOU AGREE THAT ACTFIT WILL NOT BE
              RESPONSIBLE OR LIABLE FOR ANY LOSS OR DAMAGE OF ANY SORT INCURRED
              AS THE RESULT OF ANY SUCH DEALINGS OR AS THE RESULT OF THE
              PRESENCE OF SUCH ADVERTISERS ON THE SITE.
            </p>
            <p>
              <strong>Notice.</strong>
              Except as explicitly stated otherwise, legal notices will be
              served, with respect to ACTFIT, on ACTFIT’s registered address,
              and, with respect to you, to the email address you provide to
              ACTFIT during the registration process. Notice will be deemed
              given 24 hours after email is sent, unless the sending party is
              notified that the email address is invalid. Alternatively, we may
              give you legal notice by mail to the address provided during the
              registration process. In such case, notice will be deemed given
              three days after the date of mailing.
            </p>
            <h3>DISCLAIMERS; NO WARRANTIES</h3>
            <p>
              SERVICES OFFERED VIA THE SITE ARE OFFERED AND PROVIDED BY THIRD
              PARTIES, NOT ACTFIT. YOU AGREE THAT ATTENDANCE AT OR USE OF ANY
              SUCH SERVICE IS SOLELY AT YOUR OWN RISK. IN NO EVENT SHALL ACTFIT
              BE LIABLE FOR ANY INJURY, LOSS, CLAIM, DAMAGE OR ANY SPECIAL,
              EXEMPLARY, PUNITIVE, INCIDENTAL OR CONSEQUENTIAL DAMAGES OF ANY
              KIND, WHETHER BASED IN CONTRACT, TORT OR OTHERWISE, WHICH ARISES
              OUT OF OR IS ANY WAY CONNECTED WITH A USER’S ATTENDANCE OR
              PARTICIPATION IN A SERVICE MADE AVAILABLE THROUGH THE SITE, OR THE
              PERFORMANCE OR NON-PERFORMANCE OF ANY PROVIDER IN CONNECTION WITH
              THE SERVICES. IN ADDITION, ALL USERS SPECIFICALLY UNDERSTAND AND
              AGREE THAT ANY THIRD-PARTY DIRECTING USERS TO THE SITE BY
              REFERRAL, LINK OR ANY OTHER MEANS IS NOT LIABLE TO THE USER FOR
              ANY REASON WHATSOEVER, INCLUDING BUT NOT LIMITED TO DAMAGES OR
              LOSS ASSOCIATED WITH THE USE OF THE SERVICES, THE SITE OR
              APPLICATION OR ANY CONTENT ON THE SITE. WITHOUT LIMITING ANYTHING
              HEREIN, ACTFIT DISCLAIMS ALL WARRANTIES, WHETHER STATUTORY,
              EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
              PURPOSE, RELATED TO ANY SERVICES OFFERED VIA THE SITE.
            </p>
            <p>
              IF YOU CHOOSE TO USE THE SITE OR APPLICATION, YOU DO SO AT YOUR
              SOLE RISK. YOU ACKNOWLEDGE AND AGREE THAT ACTFIT DOES NOT HAVE AN
              OBLIGATION TO CONDUCT BACKGROUND CHECKS ON ANY USER, INCLUDING,
              BUT NOT LIMITED TO, CONSUMERS AND SERVICE PROVIDERS, BUT MAY
              CONDUCT SUCH BACKGROUND CHECKS IN ITS SOLE DISCRETION.
            </p>
            <p>
              ACTFIT MAKES NO WARRANTY THAT THE SITE OR APPLICATION, AND ITS
              CONTENT, INCLUDING, BUT NOT LIMITED TO THE LISTINGS OR ANY
              SERVICES, WILL MEET YOUR REQUIREMENTS OR BE AVAILABLE ON AN
              UNINTERRUPTED, SECURE, OR ERROR-FREE BASIS. ACTFIT MAKES NO
              WARRANTY REGARDING THE QUALITY OF ANY LISTINGS OR SERVICES, OR THE
              ACCURACY, TIMELINESS, TRUTHFULNESS, COMPLETENESS OR RELIABILITY OF
              ANY CONTENT OBTAINED THROUGH THE SITE OR APPLICATION. NO ADVICE OR
              INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED FROM ACTFIT OR
              THROUGH THE SITE OR APPLICATION, WILL CREATE ANY WARRANTY NOT
              EXPRESSLY MADE HEREIN.
            </p>
            <p>
              UNLESS OTHERWISE EXPRESSLY STATED BY ACTFIT, THE SITE AND ANY
              DOWNLOADABLE SOFTWARE, CONTENT, SERVICES, OR APPLICATIONS MADE
              AVAILABLE IN CONJUNCTION WITH OR THROUGH THE SITE ARE PROVIDED “AS
              IS” AND “AS AVAILABLE” WITHOUT WARRANTIES OF ANY KIND EITHER
              EXPRESS OR IMPLIED. TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO
              APPLICABLE LAW, ACTFIT, ITS SUPPLIERS AND PARTNERS DISCLAIM ALL
              WARRANTIES, STATUTORY, EXPRESS OR IMPLIED, INCLUDING, BUT NOT
              LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
              PARTICULAR PURPOSE, AND NON-INFRINGEMENT OF PROPRIETARY RIGHTS.
            </p>
            <p>
              UNLESS OTHERWISE EXPRESSLY STATED BY ACTFIT, ACTFIT, ITS SUPPLIERS
              AND PARTNERS DO NOT WARRANT OR MAKE ANY REPRESENTATIONS (I) THAT
              THE SITE AND ANY DOWNLOADABLE SOFTWARE, CONTENT, SERVICES, OR
              APPLICATIONS MADE AVAILABLE IN CONJUNCTION WITH OR THROUGH THE
              SITE WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE
              CORRECTED, OR THAT THE SITE AND ANY DOWNLOADABLE SOFTWARE,
              CONTENT, SERVICES, OR APPLICATIONS MADE AVAILABLE IN CONJUNCTION
              WITH OR THROUGH THE SITE OR THE SERVER THAT MAKES THEM AVAILABLE
              ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR (II) REGARDING
              THE USE OF THE SITE AND ANY DOWNLOADABLE SOFTWARE, CONTENT,
              SERVICES, OR APPLICATIONS MADE AVAILABLE IN CONJUNCTION WITH OR
              THROUGH THE SITE IN TERMS OF CORRECTNESS, ACCURACY, RELIABILITY,
              OR OTHERWISE. YOU UNDERSTAND AND AGREE THAT YOU DOWNLOAD OR
              OTHERWISE OBTAIN MATERIAL OR DATA THROUGH THE USE OF THE SITE OR
              APPLICATION AT YOUR OWN DISCRETION AND RISK AND THAT YOU WILL BE
              SOLELY RESPONSIBLE FOR ANY DAMAGES TO YOUR COMPUTER SYSTEM OR LOSS
              OF DATA THAT RESULTS FROM THE DOWNLOAD OF SUCH MATERIAL OR DATA.
            </p>
            <p>
              You agree to indemnify and hold ACTFIT, its affiliated companies,
              and its suppliers and partners harmless from any claims, losses,
              damages, liabilities, including attorney’s fees, arising out of
              your use or misuse of the Site or Application, violation of these
              Terms, violation of the rights of any other person or entity, or
              any breach of the foregoing representations, warranties, and
              covenants.
            </p>
            <p>
              A provision of these Terms may be waived only by a written
              instrument executed by the party entitled to the benefit of such
              provision. The failure of any party at any time to require
              performance of any provision of these Terms will in no manner
              affect such party’s right at a later time to enforce the same. A
              waiver of any breach of any provision of these Terms will not be
              construed as a continuing waiver of other breaches of the same or
              other provisions of these Terms.
            </p>
            <p>
              UNDER NO CIRCUMSTANCES, INCLUDING, BUT NOT LIMITED TO, NEGLIGENCE,
              WILL ACTFIT OR ITS AFFILIATES, CONTRACTORS, EMPLOYEES, AGENTS, OR
              THIRD-PARTY PARTNERS OR SUPPLIERS BE LIABLE FOR ANY SPECIAL,
              INDIRECT, INCIDENTAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY
              DAMAGES ARISING FROM OR RELATED TO THE USE OF THE SITE, INCLUDING
              THOSE THAT RESULT FROM THE USE OR THE INABILITY TO USE THE
              MATERIALS ON THE SITE, OR ANY OTHER INTERACTIONS WITH ACTFIT, EVEN
              IF ACTFIT OR A ACTFIT AUTHORIZED REPRESENTATIVE HAS BEEN ADVISED
              OF THE POSSIBILITY OF SUCH DAMAGES. APPLICABLE LAW MAY NOT ALLOW
              THE LIMITATION OR EXCLUSION OF LIABILITY OR INCIDENTAL OR
              CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY
              NOT APPLY TO YOU. IN SUCH CASES, ACTFIT’S LIABILITY WILL BE
              LIMITED TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW. IN NO
              EVENT WILL ACTFIT OR ITS AFFILIATES, CONTRACTORS, EMPLOYEES,
              AGENTS, OR THIRD-PARTY PARTNERS OR SUPPLIERS HAVE ANY LIABILITY TO
              YOU FOR DAMAGES, LOSSES, AND CAUSES OF ACTION ARISING OUT OF OR
              RELATING TO THESE TERMS OR YOUR USE OF THE SITE (WHETHER IN
              CONTRACT, TORT INCLUDING NEGLIGENCE, WARRANTY, OR OTHERWISE).
            </p>

            <h3>DISPUTE RESOLUTION</h3>
            <p>
              <strong>General.</strong> Generally, if a dispute arises between
              ACTFIT and you, our goal is to provide you with a neutral and cost
              effective means of resolving the dispute quickly. Accordingly, you
              and ACTFIT agree that the parties will resolve any claim or
              controversy at law or equity that arises out of this Agreement or
              the Site (a “Claim”) in accordance with one of the subsections
              below or as you and ACTFIT otherwise agree in writing. Before
              resorting to these alternatives, we strongly encourage you to
              first contact us directly to seek a resolution. We will consider
              reasonable requests to resolve the dispute through alternative
              dispute resolution procedures, such as mediation or arbitration,
              as alternatives to litigation.
            </p>
            <p>
              <strong>Choice of Law; Forum.</strong> These Terms shall be
              governed in all respects by the laws of Switzerland, without
              regard to conflict of law provisions. You agree that any claim or
              dispute you may have against ACTFIT must be resolved by a court
              located in Zurich, except as otherwise agreed by the parties or as
              described in the Arbitration Option paragraph below. You agree to
              submit to the personal jurisdiction of the courts located within
              Zurich for the purpose of litigating all such claims or disputes.
            </p>

            <h3>MISCELLANEOUS</h3>
            <p>
              <strong>Severability.</strong> If any provision of these Terms
              shall be unlawful, void, or for any reason unenforceable, then
              that provision will be deemed severable from these Terms and will
              not affect the validity and enforceability of any remaining
              provisions.
            </p>
            <p>
              <strong>Headings.</strong> The heading references herein are for
              convenience purposes only, do not constitute a part of these
              Terms, and will not be deemed to limit or affect any of the
              provisions hereof.
            </p>
            <p>
              <strong>Entire Agreement.</strong> This is the entire agreement
              between you and ACTFIT relating to the subject matter herein and
              will not be modified except in writing, signed by both parties, or
              by a change to these Terms or Guidelines made by ACTFIT as set
              forth in the Preamble to these Terms.
            </p>
            <p>
              <strong>Claims; Statute of Limitations.</strong> YOU AND ACTFIT
              AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THESE
              TERMS OR THE SITE MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE
              CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS
              PERMANENTLY BARRED.
            </p>
            <p>
              <strong>Disclosures.</strong> The Site is operated by ACTFIT LTD,
              located at: 68-80 Hanbury Street, E1 5JL London, England. If you
              have any questions about these Terms, please contact us on our
              email: info@actfit.com.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default TermsOfService;



// WEBPACK FOOTER //
// ./src/scenes/termsOfService/index.js